import React from "react";

/** Replace these with your live URLs before deploying. */
const LINKS = {
  substack: "https://openbookclubnyc.substack.com/",
  instagram: "https://instagram.com/open.bookclub",
};

const linkClass =
  "font-[Arial,Helvetica,sans-serif] text-black underline underline-offset-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-black/20 focus-visible:ring-offset-2 focus-visible:ring-offset-stone-100";

const Construction = () => {
  return (
    <div className="min-h-screen bg-stone-100 text-stone-900 flex flex-col">
      <main className="flex-1 flex flex-col items-center justify-center px-6 py-16 sm:py-24">
        <div className="max-w-lg w-full text-center space-y-3">
          <div className="space-y-3">
            <h1 className="dm-serif-text text-4xl sm:text-5xl tracking-tight text-[#BD270B]">
              open book club
            </h1>
            <p className="text-sm font-[Arial,Helvetica,sans-serif] text-black leading-relaxed">
              This site is under construction. Check out our{" "}
              <a
                href={LINKS.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className={linkClass}
              >
                Instagram
              </a>{" "}
              or{" "}
              <a
                href={LINKS.substack}
                target="_blank"
                rel="noopener noreferrer"
                className={linkClass}
              >
                Substack
              </a>{" "}
              for the latest updates.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Construction;
